import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'
import { getLatestIntegrationStatus } from '@views/bills/utils/getLatestIntegrationStatus'

const cegidIntegrationStatusToPreviewMessageKey: Record<CegidIntegrationStatus, string> = {
  [CegidIntegrationStatus.Failed]: 'attachment_preview_modal.transfer_status.failed_sync',
  [CegidIntegrationStatus.Pending]: 'attachment_preview_modal.transfer_status.pending_sync',
  [CegidIntegrationStatus.Processing]: 'attachment_preview_modal.transfer_status.pending_sync',
  [CegidIntegrationStatus.Posted]: 'attachment_preview_modal.transfer_status.posted',
}

export const getReceiptTransferStatusPreviewMessageKey = (integrationStatuses?: IntegrationStatus[]): string | null => {
  const latestStatus = getLatestIntegrationStatus(integrationStatuses)

  if (!latestStatus) {
    return null
  }

  const { status } = latestStatus

  return cegidIntegrationStatusToPreviewMessageKey[status]
}
